import { ArrowUpRightFromCircle, SquareArrowOutUpRight } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@shared-kernel/primary/shared/shadcn/ui/hover-card";
import { cn } from "@shared-kernel/primary/shared/shadcn/utils/utils";

type TriggerVariant = "icon-only" | "icon-with-text" | "text-only";

interface PdfPreviewHoverCardProps {
  documentUrl: string;
  triggerLabel?: string;
  iframeTitle?: string;
  triggerVariant?: TriggerVariant;
  iconSize?: "sm" | "md";
  triggerClassName?: string;
}

const iconSizeClasses = {
  sm: "size-4",
  md: "size-5",
};

export const PdfPreviewHoverCard = ({
  documentUrl,
  triggerLabel,
  iframeTitle = "Aperçu du document",
  triggerVariant = "icon-with-text",
  iconSize = "sm",
  triggerClassName,
}: PdfPreviewHoverCardProps) => {
  const iframeSrc = `${documentUrl}#navpanes=0&scrollbar=0`;

  const renderTriggerContent = () => {
    switch (triggerVariant) {
      case "icon-only":
        return <SquareArrowOutUpRight size={16} className="cursor-pointer text-blue-600 visited:text-purple-600 dark:text-blue-500" />;
      case "text-only":
        return <span>{triggerLabel}</span>;
      case "icon-with-text":
      default:
        return (
          <>
            <ArrowUpRightFromCircle className={iconSizeClasses[iconSize]} />
            {triggerLabel && <span className="ml-1 text-sm">{triggerLabel}</span>}
          </>
        );
    }
  };

  const defaultTriggerClassName =
    triggerVariant === "text-only"
      ? "font-medium text-blue-600 hover:underline dark:text-blue-500"
      : "flex items-center text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300";

  return (
    <HoverCard>
      <HoverCardTrigger asChild>
        <a href={documentUrl} target="_blank" rel="noreferrer" className={cn(defaultTriggerClassName, triggerClassName)}>
          {renderTriggerContent()}
        </a>
      </HoverCardTrigger>
      <HoverCardContent side="left" align="end" className="h-[690px] w-[500px]">
        <div className="size-full">
          <iframe src={iframeSrc} height="100%" width="100%" title={iframeTitle} />
        </div>
      </HoverCardContent>
    </HoverCard>
  );
};
